import { isInViewport } from "./utils";

/** Block Contact Map */
export function blockContactMap() {

   document.body.classList.add("js");

   const blocks = document.querySelectorAll(".contact-map [data-animation-order]");
   animation(blocks);
 
   window.addEventListener(
     "scroll",
     function () {
       animation(blocks);
     },
     false
   );
 
   function animation(blocks) {
     blocks.forEach(function (block) {
       if (isInViewport(block) && !block.classList.contains("animated")) {
         block.classList.add("animated");
       }
     });
   }
}
